import { map } from 'lodash';
import { makeFetch } from './communicator'
import { getToken } from './token';

const url = '/posts'
const makeCall = options => makeFetch(
  {
    ...options,
    headers: {
      auth: getToken()
    }
  }
);

const mapKey = data => map(data, (d, key) => ({
  ...d,
  key: key + 1
}))

export const fetchAll = async () => {

  const headers = {
    auth: getToken()
  }
  const options = {
    method: 'GET',
    url,
    headers
  }
  const { data } = await makeCall(options)
  return {
    data: mapKey(data)
  };
}

export const fetchUpdate = record => {
  const options = {
    method: 'PUT',
    url: `${url}/${record.Id}`,
    data: JSON.stringify(record),
  }
  return makeCall(options)
}
export const fetchDelete = id => {
  const options = {
    method: 'DELETE',
    url: `${url}/${id}`
  }
  return makeCall(options)
}
export const fetchCreate = record => {
  const options = {
    method: 'POST',
    url,
    data: JSON.stringify({
      ...record,
      LinkToFile: "www.asd"
    }),
  }
  return makeCall(options)
}

export const getUsers = () => {
  const options = {
    method: 'GET',
    url: '/users'
  }
  return makeCall(options)
}